import { Theme, useMediaQuery } from "@mui/material";

export const useIsScreenBiggerThanSM = () => {
  const isScreenBiggerThanSM = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("sm")
  );
  return isScreenBiggerThanSM;
};
